import { Button } from '@kanda-libs/ks-design-library';
import OpenBankingMobileModal from './Modal';
import useOpenBankingMobile from './useOpenBankingMobile';

const OpenBankingInfoMobile: React.FunctionComponent = function () {
  const { onClick } = useOpenBankingMobile();
  return (
    <>
      <Button.Icon
        id="create-job-mobile-open-banking-info"
        onClick={onClick}
        icon="info"
        iconProps={{
          className: 'w-4 cursor-pointer min-w-4 text-neutral-500 ml-2',
          size: 16,
        }}
      />
      <OpenBankingMobileModal />
    </>
  );
};

export default OpenBankingInfoMobile;
